import { render, staticRenderFns } from "./media-audience.vue?vue&type=template&id=cb67d612&scoped=true"
import script from "./media-audience.vue?vue&type=script&lang=js"
export * from "./media-audience.vue?vue&type=script&lang=js"
import style0 from "./media-audience.vue?vue&type=style&index=0&id=cb67d612&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb67d612",
  null
  
)

export default component.exports